// @flow
import { useContext } from 'react';
import { WorkspaceUIContext } from '../context/WorkspaceUIContext';
const useWorkspaceUIContext = () => {
    const ctx = useContext(WorkspaceUIContext);
    return ctx;
};
export default useWorkspaceUIContext;
